import gaEventTracker, { events } from "util/gaEventTracker";

export const types = {
    FILTER_ECHEQ_LIST: "echecks/ECHECK_LIST_REQUEST",
    SET_ECHEQ_LIST: "echecks/ECHECK_LIST_SUCCESS",
    SET_ECHEQ_OPTION: "echecks/SET_ECHEQ_OPTION",
    SET_ECHEQ_FILTERS: "echecks/CHANGE_ECHECKS_FILTERS",
    SET_SELECTED_ECHECK: "echecks/SET_SELECTED_ECHECK",
    SET_ECHEQ_TODO_ACTIONS: "echecks/SET_ECHEQ_TODO_ACTIONS",
    EMIT_ECHEQ_BENEFICIARY: "echecks/EMIT_ECHEQ_BENEFICIARY",
    EMIT_ECHEQ_DATA: "echecks/EMIT_ECHEQ_DATA",
    EMIT_ECHEQ: "echecks/EMIT_ECHEQ_REQUEST",
    ECHECK_TICKET_SUCCESS: "echecks/EMIT_ECHEQ_SUCCESS",
    CLEAN_ECHEQ_ACTION: "echecks/CLEAN_ECHEQ_ACTION",
    CLEAN_ECHECK_TICKET: "echecks/CLEAN_ECHECK_TICKET",
    SET_ECHEQ_REPUDIATE_MOTIVE: "echecks/SET_ECHEQ_REPUDIATE_MOTIVE",
    EXECUTE_ACTION_ECHEQ: "echecks/EXECUTE_ACTION_ECHEQ",
    EXECUTE_ACTION_ECHEQ_TRANSACTION: "echecks/EXECUTE_ACTION_ECHEQ_TRANSACTION",
    EXECUTE_ACTION_ECHEQ_MULTIPLE: "echecks/EXECUTE_ACTION_ECHEQ_MULTIPLE",
    ECHEQ_ACTION_SUBMITTING: "echecks/ECHEQ_ACTION_SUBMITTING",
    ENDORSE_ECHEQ_DATA: "echecks/ENDORSE_ECHEQ_DATA",
    ENDORSE_ECHEQ: "echecks/ENDORSE_ECHEQ_REQUEST",
    BENEFICIARY_ENDORSE_ECHEQ_DATA: "echecks/BENEFICIARY_ENDORSE_ECHEQ_DATA",
    ENDORSE_MULTIPLE_ECHEQ: "echecks/ENDORSE_MULTIPLE_ECHEQ",
    SET_ECHEQ_FETCHING: "echecks/SET_ECHEQ_FETCHING",
    CESION_ECHEQ_BENEFICIARY: "echecks/CESION_ECHEQ_BENEFICIARY",
    CESION_ECHEQ_DATA: "echecks/CESION_ECHEQ_DATA",
    CESION_ECHEQ: "echecks/CESION_ECHEQ",
    ECHEQ_DETAIL_REQUEST: "echecks/ECHEQ_DETAIL_REQUEST",
    ECHEQ_DETAIL_SUCCESS: "echecks/ECHEQ_DETAIL_SUCCESS",
    AMOUNT_ECHECK_REQUEST: "echecks/AMOUNT_ECHECK_REQUEST",
    AMOUNT_ECHECK_SUCCESS: "echecks/AMOUNT_ECHECK_SUCCESS",
    ACCEPT_RETURN_ECHEQ: "echecks/ACCEPT_RETURN_ECHEQ",
    SET_REQUEST_RETURN_SOLICITANT_NAME: "echecks/SET_REQUEST_RETURN_SOLICITANT_NAME",
    BANKED_BENEFICIARY: "checks/BANKED_BENEFICIARY",
    SET_AMOUNT_ECHECK_DATA: "echecks/SET_AMOUNT_ECHECK_DATA",
    REQUEST_AMOUNT_ECHECK_DATA: "echeck/REQUEST_AMOUNT_ECHECK_DATA",
    DOWNLOAD_ECHEQ_LIST_REQUEST: "echecks/DOWNLOAD_ECHEQ_LIST_REQUEST",
    DOWNLOAD_ECHEQ_LIST_FAILURE: "echecks/DOWNLOAD_ECHEQ_LIST_FAILURE",
    DOWNLOAD_ECHEQ_LIST_SUCCESS: "echecks/DOWNLOAD_ECHEQ_LIST_SUCCESS",
    SELECT_BENEFICIARY: "echecks/SELECT_BENEFICIARY",
    SET_SUMMARY_MASSIVE_ECHECK: "echecks/SET_SUMMARY_MASSIVE_ECHECK",
    SOLICIT_AVAL_REQUEST: "debin/SOLICIT_AVAL_REQUEST",
    SOLICIT_AVAL_SUCCESS: "debin/SOLICIT_AVAL_SUCCESS",
    SOLICIT_AVAL_FAILURE: "debin/SOLICIT_AVAL_FAILURE",
    UPDATE_AVAL_REQUEST: "debin/UPDATE_AVAL_REQUEST",
    UPDATE_AVAL_SUCCESS: "debin/UPDATE_AVAL_SUCCESS",
    UPDATE_AVAL_FAILURE: "debin/UPDATE_AVAL_FAILURE",
    SET_AVAL_DETAIL: "debin/SET_AVAL_DETAIL",
    DOWNLOAD_MASSIVE_ECHEQ_TEMPLATE_REQUEST: "echecks/DOWNLOAD_MASSIVE_ECHEQ_TEMPLATE_REQUEST",
    DOWNLOAD_MASSIVE_ECHEQ_TEMPLATE_FAILURE: "echecks/DOWNLOAD_MASSIVE_ECHEQ_TEMPLATE_FAILURE",
    DOWNLOAD_MASSIVE_ECHEQ_TEMPLATE_SUCCESS: "echecks/DOWNLOAD_MASSIVE_ECHEQ_TEMPLATE_SUCCESS",
    CREATE_MASSIVEECHEQ_REQUEST: "echecks/CREATE_MASSIVEECHEQ_REQUEST",
    CREATE_MASSIVEECHEQ_SUCCESS: "echecks/CREATE_MASSIVEECHEQ_SUCCESS",
    CREATE_MASSIVEECHEQ_FAILURE: "echecks/CREATE_MASSIVEECHEQ_FAILURE",
    CANCEL_TRANSFER_REQUEST: "echecks/CANCEL_TRANSFER_REQUEST",
    SET_ECHEQ_PRODUCT_ID: "echecks/SET_ECHEQ_PRODUCT_ID",
    SET_ECHEQ_CREDIT_ACCOUNT: "echecks/SET_ECHEQ_CREDIT_ACCOUNT",
    CANCEL_ENDORSE_ECHEQ: "echecks/CANCEL_ENDORSE_ECHEQ",
    REQUEST_CAC_REQUEST: "echecks/REQUEST_CAC_REQUEST",
    REQUEST_CAC_SUCCESS: "echecks/REQUEST_CAC_SUCCESS",
    REQUEST_CAC_FAILURE: "echecks/REQUEST_CAC_FAILURE",
    ACCEPT_RETURN_REJECTED_REQUEST: "echecks/ACCEPT_RETURN_REJECTED_REQUEST",
    ACCEPT_RETURN_REJECTED_SUCCESS: "echecks/ACCEPT_RETURN_REJECTED_SUCCESS",
    ACCEPT_RETURN_REJECTED_ERROR: "echecks/ACCEPT_RETURN_REJECTED_ERROR",
};

export const INITIAL_STATE = {
    fetching: false,
    echeqList: [],
    echeqPagination: {},
    environmentCuit: "",
    hasMoreData: false,
    echeqFilters: { orderColumName: "fecha_pago", orderDirection: "ascendent", pageNumber: 1 },
    optionEcheq: "",
    selectedEcheck: null,
    emitEcheqData: {},
    echeqsToEmit: [],
    echeckTicket: { status: "", idTransaction: "" },
    echeqsToDoActions: { isSubmitting: false },
    echeqsEndorseData: {},
    cesionEcheqData: {},
    echeqDetail: {},
    echeckAmountData: {},
    fetchingEcheqList: false,
    requestEcheckAmountData: {},
    massiveEcheckData: {
        typePayment: "",
        account: "",
        description: "",
        currency: "",
        amount: null,
        file: null,
        dateProcess: null,
        signatures: null,
        pendingDispatch: null,
        idTransactionStatus: "",
        modificationDateTime: null,
        userEditorFullName: "",
        creatorFullName: "",
        creationDate: null,
    },
    cacData: {},
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        echeqList,
        summary,
        totalPages,
        pageNumber,
        environmentCuit,
        optionEcheq,
        echeqFilters,
        selectedEcheck,
        echeqs,
        beneficiary,
        formData,
        echeckTicket,
        specialAttribute,
        endorseData,
        cesionData,
        echeqDetail,
        echeckAmountData,
        solicitantName,
        requestEcheckAmountData,
        massiveEcheckData,
        avalToSolicit,
        avalToUpdate,
        aval,
        echeqsToDoActions,
        credentialType,
        signatures,
        pendingDispatch,
        idTransactionStatus,
        modificationDateTime,
        userEditorFullName,
        creatorFullName,
        creationDate,
        productId,
        accountDescription,
        cacData,
        data,
    } = action;

    switch (action.type) {
        case types.SET_ECHEQ_FETCHING:
            return {
                ...state,
                fetching: false,
            };
        case types.FILTER_ECHEQ_LIST:
            return {
                ...state,
                fetching: true,
            };
        case types.SET_ECHEQ_LIST:
            return {
                ...state,
                echeqList: [...state.echeqList, ...action.echeqList],
                hasMoreData: pageNumber < totalPages,
                echeqPagination: { totalPages, pageNumber },
                environmentCuit,
            };
        case types.SET_ECHEQ_OPTION:
            return {
                ...state,
                optionEcheq,
                echeqList: [],
            };
        case types.SET_ECHEQ_FILTERS:
            return {
                ...state,
                echeqFilters,
                echeqList: [],
            };
        case types.SET_SELECTED_ECHECK:
            return {
                ...state,
                selectedEcheck,
            };
        case types.SET_ECHEQ_TODO_ACTIONS:
            return {
                ...state,
                echeqsToDoActions: echeqs,
            };
        case types.EMIT_ECHEQ_BENEFICIARY:
            return { ...state, emitEcheqData: { ...state.emitEcheqData, beneficiary } };
        case types.EMIT_ECHEQ_DATA:
            return {
                ...state,
                emitEcheqData: {
                    ...state.emitEcheqData,
                    ...formData,
                },
                echeqsToEmit: echeqList,
            };
        case types.CLEAN_ECHEQ_ACTION:
            return {
                ...state,
                echeqsToDoActions: { ...state.echeqsToDoActions, isSubmitting: false },
                echeqsEndorseData: {},
                // echeqTransactionData: {},
                emitEcheqData: {},
                echeqList: [],
                echeqsToEmit: [],
                cesionEcheqData: {},
            };
        case types.ECHECK_TICKET_SUCCESS:
            return {
                ...state,
                echeckTicket,
            };
        case types.CLEAN_ECHECK_TICKET:
            return {
                ...state,
                echeckTicket: { status: "", idTransaction: "" },
                fetching: false,
            };
        case types.SET_ECHEQ_REPUDIATE_MOTIVE:
            return {
                ...state,
                echeqsToDoActions: { ...state.echeqsToDoActions, specialAttribute },
            };
        case types.ECHEQ_ACTION_SUBMITTING:
            return {
                ...state,
                echeqsToDoActions: { ...state.echeqsToDoActions, isSubmitting: action.isSubmitting },
            };
        case types.BENEFICIARY_ENDORSE_ECHEQ_DATA:
            return {
                ...state,
                echeqsEndorseData: { ...state.echeqsEndorseData, beneficiary },
            };
        case types.ENDORSE_ECHEQ_DATA:
            return {
                ...state,
                echeqsEndorseData: { ...state.echeqsEndorseData, endorseData },
            };
        case types.CESION_ECHEQ_BENEFICIARY:
            return { ...state, cesionEcheqData: { ...state.cesionEcheqData, beneficiary } };
        case types.CESION_ECHEQ_DATA:
            return { ...state, cesionEcheqData: { ...state.cesionEcheqData, cesionData } };
        case types.ECHEQ_DETAIL_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.ECHEQ_DETAIL_SUCCESS:
            return {
                ...state,
                echeqDetail,
                environmentCuit: action.environmentCuit,
                fetching: false,
            };
        case types.AMOUNT_ECHECK_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AMOUNT_ECHECK_SUCCESS:
            return {
                ...state,
                echeckAmountData,
            };
        case types.SET_REQUEST_RETURN_SOLICITANT_NAME:
            return {
                ...state,
                echeqsToDoActions: { ...state.echeqsToDoActions, solicitantName },
            };
        case types.SET_AMOUNT_ECHECK_DATA:
            return {
                ...state,
                requestEcheckAmountData,
            };

        case types.DOWNLOAD_ECHEQ_LIST_REQUEST:
            return {
                ...state,
                fetchingEcheqList: true,
            };
        case types.DOWNLOAD_ECHEQ_LIST_FAILURE:
        case types.DOWNLOAD_ECHEQ_LIST_SUCCESS:
            return {
                ...state,
                fetchingEcheqList: false,
            };
        case types.SELECT_BENEFICIARY:
            return {
                ...state,
                beneficiary,
            };
        case types.SET_SUMMARY_MASSIVE_ECHECK:
            return {
                ...state,
                massiveEcheckData,
            };
        case types.SOLICIT_AVAL_REQUEST:
            return {
                ...state,
                credentialType,
                avalToSolicit,
                fetching: true,
            };
        case types.SOLICIT_AVAL_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.SOLICIT_AVAL_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.UPDATE_AVAL_REQUEST:
            return {
                ...state,
                aval,
                avalToUpdate,
                fetching: true,
            };
        case types.UPDATE_AVAL_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.UPDATE_AVAL_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.SET_AVAL_DETAIL:
            return {
                ...state,
                echeqsToDoActions,
                beneficiary,
            };
        case types.DOWNLOAD_MASSIVE_ECHEQ_TEMPLATE_REQUEST:
            return {
                ...state,
            };
        case types.DOWNLOAD_MASSIVE_ECHEQ_TEMPLATE_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.DOWNLOAD_MASSIVE_ECHEQ_TEMPLATE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.CREATE_MASSIVEECHEQ_REQUEST:
            return {
                ...state,
                fetching: true,
                summary,
            };
        case types.CREATE_MASSIVEECHEQ_SUCCESS:
            return {
                ...state,
                fetching: false,
                summary: {
                    ...state.summary,
                    signatures,
                    pendingDispatch,
                    idTransactionStatus,
                    modificationDateTime,
                    userEditorFullName,
                    creatorFullName,
                    creationDate,
                },
            };

        case types.CREATE_MASSIVEECHEQ_FAILURE:
            return {
                ...state,
                fetching: false,
                summary,
            };
        case types.SET_ECHEQ_PRODUCT_ID:
            return {
                ...state,
                echeqsToDoActions: {
                    ...state.echeqsToDoActions,
                    productId,
                },
            };
        case types.SET_ECHEQ_CREDIT_ACCOUNT:
            return {
                ...state,
                echeqsToDoActions: {
                    ...state.echeqsToDoActions,
                    accountDescription,
                },
            };
        case types.REQUEST_CAC_REQUEST:
            return {
                ...state,
                credentialType,
                cacData,
                fetching: true,
            };
        case types.REQUEST_CAC_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.REQUEST_CAC_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.ACCEPT_RETURN_REJECTED_REQUEST:
            return {
                ...state,
                credentialType,
                data,
                fetching: true,
            };
        case types.ACCEPT_RETURN_REJECTED_SUCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.ACCEPT_RETURN_REJECTED_ERROR:
            return {
                ...state,
                fetching: false,
            };

        default:
            return state;
    }
};

export const actions = {
    filterEcheqList: (filters) => ({
        type: types.FILTER_ECHEQ_LIST,
        filters,
    }),
    setEcheqOption: (optionEcheq) => ({
        type: types.SET_ECHEQ_OPTION,
        optionEcheq,
    }),
    setEcheqFilters: (echeqFilters) => ({
        type: types.SET_ECHEQ_FILTERS,
        echeqFilters,
    }),
    setSelectedEcheck: (selectedEcheck) => ({
        type: types.SET_SELECTED_ECHECK,
        selectedEcheck,
    }),
    setEchecksToDoActions: (echeqs) => ({
        type: types.SET_ECHEQ_TODO_ACTIONS,
        echeqs,
    }),
    beneficiaryEcheq: (beneficiary, stringType) => ({
        type: stringType,
        beneficiary,
    }),
    echeqEmitData: ({ formData, echeqList }) => ({
        type: types.EMIT_ECHEQ_DATA,
        formData,
        echeqList,
    }),
    emitEcheq: (echeqEmitData, formikBag, credentialType) => {
        gaEventTracker.triggerEvent(
            events.newEcheq({
                character: echeqEmitData?.character,
                mode: echeqEmitData?.mode,
            }),
        );
        return {
            type: types.EMIT_ECHEQ,
            echeqEmitData,
            formikBag,
            credentialType,
        };
    },
    cleanEcheqAction: () => ({
        type: types.CLEAN_ECHEQ_ACTION,
    }),
    cleanEcheckTicket: () => ({
        type: types.CLEAN_ECHECK_TICKET,
    }),
    setEcheqsSpecialAttribute: (specialAttribute) => ({
        type: types.SET_ECHEQ_REPUDIATE_MOTIVE,
        specialAttribute,
    }),
    executeActionEcheq: (echeqAction) => ({
        type: types.EXECUTE_ACTION_ECHEQ,
        echeqAction,
    }),
    executeActionEcheqTransaction: (echeqAction) => ({
        type: types.EXECUTE_ACTION_ECHEQ_TRANSACTION,
        echeqAction,
    }),
    executeActionEcheqMultiple: (echeqData, formikBag, credentialType) => ({
        type: types.EXECUTE_ACTION_ECHEQ_MULTIPLE,
        echeqData,
        formikBag,
        credentialType,
    }),
    setEcheqActionSubmitting: (isSubmitting) => ({
        type: types.ECHEQ_ACTION_SUBMITTING,
        isSubmitting,
    }),
    endorseEcheqData: (endorseData) => ({
        type: types.ENDORSE_ECHEQ_DATA,
        endorseData,
    }),
    endorseEcheq: (echeqEndorseData, formikBag, credentialType) => ({
        type: types.ENDORSE_ECHEQ,
        echeqEndorseData,
        formikBag,
        credentialType,
    }),
    endorseMultipleEcheq: (echeqEndorseData, formikBag, credentialType) => ({
        type: types.ENDORSE_MULTIPLE_ECHEQ,
        echeqEndorseData,
        formikBag,
        credentialType,
    }),
    cancelEndorseEcheq: (echeqEndorseData, formikBag, credentialType) => ({
        type: types.CANCEL_ENDORSE_ECHEQ,
        echeqEndorseData,
        formikBag,
        credentialType,
    }),
    echeqCesionData: (cesionData) => ({
        type: types.CESION_ECHEQ_DATA,
        cesionData,
    }),
    cesionEcheq: (echeqCesionData, formikBag, credentialType) => ({
        type: types.CESION_ECHEQ,
        echeqCesionData,
        formikBag,
        credentialType,
    }),
    requestEcheqDetail: (echeqId) => ({
        type: types.ECHEQ_DETAIL_REQUEST,
        echeqId,
    }),
    requestAmountEchecks: (idAccount) => ({
        type: types.AMOUNT_ECHECK_REQUEST,
        idAccount,
    }),
    cleanAmountEchechs: () => ({
        type: types.AMOUNT_ECHECK_SUCCESS,
        echeckAmountData: {},
    }),
    acceptReturnEcheq: (echeqAceptReturnData, formikBag, credentialType) => ({
        type: types.ACCEPT_RETURN_ECHEQ,
        echeqAceptReturnData,
        formikBag,
        credentialType,
    }),
    setRequestReturnSolicitanInformation: (cuit) => ({
        type: types.SET_REQUEST_RETURN_SOLICITANT_NAME,
        cuit,
    }),
    bankedBeneficiary: (document, setSubmitting, stringType, setErrors, setOpenSidebarForm = null, resetForm) => ({
        type: types.BANKED_BENEFICIARY,
        document,
        setSubmitting,
        stringType,
        setErrors,
        setOpenSidebarForm,
        resetForm,
    }),
    setRequestEcheckAmountData: (requestEcheckAmountData) => ({
        type: types.SET_AMOUNT_ECHECK_DATA,
        requestEcheckAmountData,
    }),
    requestEcheckAmount: (requestEcheckAmountData, formikBag, credentialType) => ({
        type: types.REQUEST_AMOUNT_ECHECK_DATA,
        requestEcheckAmountData,
        formikBag,
        credentialType,
    }),
    downloadEcheqList: (filters) => ({
        type: types.DOWNLOAD_ECHEQ_LIST_REQUEST,
        filters,
    }),
    setBeneficiary: (beneficiary) => ({
        type: types.SELECT_BENEFICIARY,
        beneficiary,
    }),
    summaryMassiveEcheck: (massiveEcheckData) => ({
        type: types.SET_SUMMARY_MASSIVE_ECHECK,
        massiveEcheckData,
    }),
    solicitAval: (avalToSolicit, formikBag, credentialType) => ({
        type: types.SOLICIT_AVAL_REQUEST,
        avalToSolicit,
        formikBag,
        credentialType,
    }),
    updateAvalState: (avalToUpdate, formikBag, credentialType) => ({
        type: types.UPDATE_AVAL_REQUEST,
        avalToUpdate,
        formikBag,
        credentialType,
    }),
    setAvalDetail: (data) => ({
        type: types.SET_AVAL_DETAIL,
        echeqsToDoActions: { ...data.echeqsToDoActions, idTransaction: data?.idTransaction },
        beneficiary: data.beneficiary,
    }),
    downloadTemplate: () => ({
        type: types.DOWNLOAD_MASSIVE_ECHEQ_TEMPLATE_REQUEST,
    }),
    validateMassiveEcheq: (summary, formikBag, credentialType) => ({
        type: types.CREATE_MASSIVEECHEQ_REQUEST,
        summary,
        formikBag,
        credentialType,
    }),
    cancelTransfer: (summary, formikBag, credentialType) => ({
        type: types.CANCEL_TRANSFER_REQUEST,
        summary,
        formikBag,
        credentialType,
    }),
    setEcheqsProductId: (productId) => ({
        type: types.SET_ECHEQ_PRODUCT_ID,
        productId,
    }),

    setEcheqsCreditAccountDescription: (accountDescription) => ({
        type: types.SET_ECHEQ_CREDIT_ACCOUNT,
        accountDescription,
    }),

    requestCac: (cacData, formikBag, credentialType) => ({
        type: types.REQUEST_CAC_REQUEST,
        cacData,
        formikBag,
        credentialType,
    }),

    acceptReturnRejected: (data, formikBag, credentialType) => ({
        type: types.ACCEPT_RETURN_REJECTED_REQUEST,
        data,
        formikBag,
        credentialType,
    }),
};

export const selectors = {
    getFetching: ({ echecks }) => echecks.fetching,
    getEcheqsList: ({ echecks }) => echecks.echeqList,
    getEcheqsPagination: ({ echecks }) => echecks.echeqPagination,
    getEnvironmentCuit: ({ echecks }) => echecks.environmentCuit,
    getHasMoreData: ({ echecks }) => echecks.hasMoreData,
    getEcheqFilters: ({ echecks }) => echecks.echeqFilters,
    getEcheqOption: ({ echecks }) => echecks.optionEcheq,
    getSelectedEcheck: ({ echecks }) => echecks.selectedEcheck,
    getEcheqsEmitData: ({ echecks }) => echecks.emitEcheqData,
    getEcheqsToEmit: ({ echecks }) => echecks.echeqsToEmit,
    getEcheqsEndorseData: ({ echecks }) => echecks.echeqsEndorseData,
    getEmitCesionData: ({ checks }) => checks.cesionEcheqData,
    getFetchingEcheqList: ({ checks }) => checks.fetchingEcheqList,
    getEcheqsToDoActions: ({ echecks }) => echecks.echeqsToDoActions,
};
